// Dates des contrats (semaine 2, 04/11/2026). Pur, sans dépendance : testé dans contractDates.test.ts.

// « En cours » se lit sur les dates. Une ligne cochée active dont la fin est passée est « expirée » :
// c'est un contrat à prolonger ou à clôturer (liste « à reconduire »), plus un contrat en cours.
export type ContractLineStatus = 'en_cours' | 'a_venir' | 'expire' | 'clos';

export const contractLineStatus = (
  l: { isActive: boolean; startDate: string | null; endDate: string | null },
  today: string = new Date().toISOString().slice(0, 10),
): ContractLineStatus =>
  !l.isActive ? 'clos'
    : (l.startDate && l.startDate > today) ? 'a_venir'
      : (l.endDate && l.endDate < today) ? 'expire'
        : 'en_cours';

const iso = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

/** Ajoute un mois à une date ISO. Une fin de mois reste une fin de mois (31/10 → 30/11, 30/11 → 31/12). */
export const addOneMonthIso = (isoDate: string): string => {
  const [y, m, d] = isoDate.split('-').map(Number);
  const lastOfThis = new Date(y, m, 0).getDate();      // m est 1-based : new Date(y, m, 0) = dernier jour du mois m
  const lastOfNext = new Date(y, m + 1, 0).getDate();
  if (d === lastOfThis) return iso(new Date(y, m, lastOfNext));
  return iso(new Date(y, m, Math.min(d, lastOfNext)));
};
